import { useState } from "react";
import AttendanceSeries from "./AttendanceSeries";
import StatsDateSelector from "./StatsDateSelector";
import StatsEventFilters from "./StatsEventFilters";
import moment from "moment";
import { isAssaigDeMusics, isReunio } from "../../utils/utils";
import { isHiddenStatsRehearsal } from './statsEventCategories';

function StatsGlobalAttendanceTab({
    filtersEvents,
    setFiltersEvents,
    passatFirst,
    setPassatFirst,
    minAttendees,
    setMinAttendees,
    events,
    eventCategories,
    castellersInfo,
    setChosenUsers
}) {
    const [start_date, setStart_date] = useState(moment().startOf('year').format('YYYY-MM-DD'))

    // Default: 31st December of this year
    const [end_date, setEnd_date] = useState(moment().endOf('year').format('YYYY-MM-DD'))

    const filteredEvents = events
        .filter(e => moment(e['data-esperada-inici']).isBetween(start_date, end_date, 'day', '[]'))
        .filter(e => filtersEvents?.activitats ? e.tipus !== 'activitat' : true)
        .filter(e => filtersEvents?.actuacions ? e.tipus !== 'actuació' : true)
        .filter(e => filtersEvents?.assaigs ? (e.tipus !== 'assaig' || isAssaigDeMusics(e)) : true)
        .filter(e => !isHiddenStatsRehearsal(e, filtersEvents))
        .filter(e => filtersEvents?.comercials ? !e.title?.toLowerCase().includes('comercial') && !e.title?.toLowerCase().includes('pilar') : true)
        .filter(e => filtersEvents?.reunions ? !isReunio(e) : true)
        .filter(e => filtersEvents?.ids?.length > 0 ? !filtersEvents.ids.includes(e.id) : true)
        .filter(e => filtersEvents?.titles?.length > 0 ? !filtersEvents.titles.includes(e.title) : true)
        .sort((ev_a, ev_b) => moment(ev_a?.['data-esperada-inici']).diff(moment(ev_b?.['data-esperada-inici'])))

    return (
        <>
            <StatsDateSelector
                start_date={start_date}
                setStart_date={setStart_date}
                end_date={end_date}
                setEnd_date={setEnd_date}
            />
            
            <StatsEventFilters
                filtersEvents={filtersEvents}
                setFiltersEvents={setFiltersEvents}
                events={events}
                eventCategories={eventCategories}
                minAttendees={minAttendees}
                setMinAttendees={setMinAttendees}
                setChosenUsers={setChosenUsers}
                castellersInfo={castellersInfo}
            />

            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, marginBottom: 10 }}>
                    <h2>Assistència als esdeveniments</h2>

                    <div>
                        <button
                            onClick={() => setPassatFirst(prev => !prev)}
                        >
                            {
                                !passatFirst ? <>Prioritza assistència <strong>passada</strong></> :
                                <>Prioritza assistència <strong>futura</strong></>
                            }
                        </button>
                    </div>
                </div>
                <AttendanceSeries
                    filteredEvents={filteredEvents}
                    filtersEvents={filtersEvents}
                    setFiltersEvents={setFiltersEvents}
                    passatFirst={passatFirst}
                    setPassatFirst={setPassatFirst}
                    minAttendees={minAttendees}
                />
            </div>
        </>
    );
}

export default StatsGlobalAttendanceTab;
